<template>
  <div id="about" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="about_us bg-blur">
      <div class="cons">
        <div class="content-message">
          <h3 style="margin-bottom: 20px;">{{title}}</h3>
          <div v-html="content" class="mycontent">{{content}}</div>
        </div>
      </div>
    </div>

    <div class="container bottom-mes" style="max-width: 800px !important;">
      <div class="organ mess" style="margin: 50px 0 0 0;">
        <el-link :underline="false">董事长致辞</el-link>
        <!-- <p style="font-size: 22px !important; font-weight: bolder;">General Manager’s speech</p> -->
      </div>
      <el-divider class="space"></el-divider>
      <div style="width: 100%;text-align: center;margin-bottom: 30px;">
        <img src="../assets/img/zongjingli.jpg" style="margin-top: 30px;">
      </div>
      <p>电脑是人脑的延伸，软件是智慧的结晶。</p>
      <p>
        人类用高新技术将自己带入更加文明、更加富有、更加和谐、更加美好的社会。我们国超信息科技有限公司始终坚持“赋予信息以高质量”这一企业理念，始终贯彻“高质量、快速度、低成本、客户满意”这一经营方针和“诚实、努力、
        虚心”这一用人原则，始终站在客户的立场以崭新的创意和灵活的构思为客户提供专业优质的服务。创造性的提升客户的商品品牌和价值，我们愿成为众多企业喜忧与共、并肩战斗的伙伴。
      </p>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'about',
    data() {
      return {
        visible: false,
        activeIndex: this.$route.path,
        content: "",
        title: ''
      }
    },
    components: {
      navheader,
      fixheader,
      filing
    },
    beforeCreate() {
      this.axios.get(this.$http + "api/index/getAbout", {
          params: {

          }
        })
        .then((res) => {
          this.content = res.data.data[0].content;
          this.title = res.data.data[0].title;
        })
        .catch((err) => {})
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
    },
  }
</script>

<style>
  #about .mess {
    margin-top: 30px !important;
  }

  #about .mess a {
    font-size: 35px !important;
  }

  #about .bottom-mes {
    margin-bottom: 50px;
  }

  #about .bottom-mes p {
    line-height: 30px !important;
  }

  #about div.space {
    height: 3px !important;
    position: relative;
  }

  #about div.space:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  .mycontent * {
    color: #ffffff;
  }

  @media (max-width: 800px) {
    #about .cons {
      width: 90% !important;
      margin: 20px 5% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/content/About_us.vue